<template>
	<b-modal
		ref="modal"
		id="confirm-dialog"
		hide-header
		hide-footer
		centered
		no-close-on-backdrop
		body-class="modal__confirm"
	>
		<div class="modal__message">
			{{ message }}
		</div>
		<div class="modal__controls">
			<button class="btn btn-secondary mr-5" @click="refuseDelete">
				Cancel
			</button>
			<button class="btn btn-primary" @click="confirmDelete">
				Delete
			</button>
		</div>
	</b-modal>
</template>

<script>
export default {
	name: "ConfirmDialog",
	props: ["message"],
	methods: {
		refuseDelete: function () {
			this.$emit("refusedelete");
		},
		confirmDelete: function () {
			this.$emit("confirmdelete");
		},
		show: function () {
			this.$refs["modal"].show();
		},
		hide: function () {
			this.$refs["modal"].hide();
		},
	},
};
</script>

<style>
.modal__controls {
	display: flex;
	align-items: center;
	justify-content: flex-end;
}
.modal__message {
	font-weight: bold;
	margin-bottom: 3rem;
}
</style>